import '../static/Hero.css';
import React__default from "react";
import clsx from "clsx";
import { C as Col } from "./Col.COJSUXXS.mjs";
import { a as SectionWrap } from "./SectionWrap.DExzuSui.mjs";
import { b as SectionHeader } from "./SectionHeader.VCo9GnTI.mjs";
import { u as useBetterMediaQuery } from "./useBetterMediaQuery.xTM_WrtF.mjs";
import { b as breakpoints } from "./sword.DtiKVPhx.mjs";
const hero = `_hero_4bdc5b1`;
const animation = `_animation_0739b2f`;
const vertical = `_vertical_8be4941`;
const horizontal = `_horizontal_2a1f20e`;
const layerOne = `_layerOne_5560239`;
const layerTwo = `_layerTwo_53d770d`;
const layerThree = `_layerThree_6e9058a`;
const layerAnimation = `_layerAnimation_fff447e`;
const layerAnimationHorizontal = `_layerAnimationHorizontal_2971620`;
const header = `_header_9d6c29d`;
const media = `_media_a26547a`;
const mediaRatio11 = `_mediaRatio11_5df7dc6`;
const mediaRatio21 = `_mediaRatio21_f754670`;
const mediaRatio32 = `_mediaRatio32_f2ad315`;
const mediaRatio169 = `_mediaRatio169_9199dcc`;
const styles = { hero, animation, vertical, horizontal, layerOne, layerTwo, layerThree, layerAnimation, layerAnimationHorizontal, header, media, mediaRatio11, mediaRatio21, mediaRatio32, mediaRatio169 };
const Animation = ({ className }) => {
  return /* @__PURE__ */ React__default.createElement("div", { className: clsx(styles.animation, className), "data-testid": "animation" }, /* @__PURE__ */ React__default.createElement("div", { className: clsx(styles.layerOne, className) }), /* @__PURE__ */ React__default.createElement("div", { className: clsx(styles.layerTwo, className) }), /* @__PURE__ */ React__default.createElement("div", { className: clsx(styles.layerThree, className) }));
};
const HERO_ASPECT_RATIOS = ["1:1", "3:2", "2:1", "16:9"];
const Hero = ({
  className,
  sectionHeader,
  backgroundGradient = true,
  children,
  layout = "vertical",
  mediaRatio = "3:2",
  ...props
}) => {
  const isHorizontal = layout === "horizontal";
  const isMobile = useBetterMediaQuery(`(max-width: ${breakpoints.maxSm})`);
  return /* @__PURE__ */ React__default.createElement(
    SectionWrap,
    {
      "data-ui-hero": true,
      className: clsx(styles.hero, styles[layout], className),
      "data-layout": layout,
      ...props
    },
    backgroundGradient && /* @__PURE__ */ React__default.createElement(Animation, { className: clsx(styles[layout]) }),
    /* @__PURE__ */ React__default.createElement(
      Col,
      {
        sm: 12,
        md: isHorizontal ? 3 : 12,
        lg: isHorizontal ? 6 : 12,
        "data-testid": "colHeader"
      },
      /* @__PURE__ */ React__default.createElement(
        SectionHeader,
        {
          className: clsx(styles.header, styles[layout]),
          ...sectionHeader,
          titleSize: sectionHeader.titleSize || "4xl",
          titleSeoLevel: "h1",
          "data-testid": "header",
          xAlign: isHorizontal && !isMobile ? "left" : "center"
        }
      )
    ),
    /* @__PURE__ */ React__default.createElement(
      Col,
      {
        sm: 12,
        md: isHorizontal ? 3 : 12,
        lg: isHorizontal ? 6 : 12,
        "data-testid": "colMedia"
      },
      /* @__PURE__ */ React__default.createElement(
        "div",
        {
          className: clsx(
            styles.media,
            styles[layout],
            styles[`mediaRatio${mediaRatio.replace(":", "")}`]
          ),
          "data-testid": "media"
        },
        children
      )
    )
  );
};
export {
  HERO_ASPECT_RATIOS as H,
  Hero as a
};
//# sourceMappingURL=Hero.BOKC3iRi.mjs.map
